const key = "add-role-based-validation";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const buildRoleCondition = (id, value) => ({
	"Id": id,
	"Operator": {
		"Id": 99,
		"Code": "EQUALTO",
		"Name": "Equal To"
	},
	"Value": value
});

const buildRoleChildRule = (id, conditionId, value) => ({
	"Id": id,
	"Operator": {
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine": {
		"Id": 9001,
		"Code": "ROLE",
		"Name": "Role"
	},
	"Conditions": [
		buildRoleCondition(conditionId, value)
	]
});

const ruleJson = () => ({
	"Id": 990001,
	"Title": "Only SYSADMIN and AGENT roles may complete this report",
	"Operator": {
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Children": [
		buildRoleChildRule(990002, 990003, "SYSADMIN"),
		buildRoleChildRule(990004, 990005, "AGENT")
	],
	"Triggers": [
		{
			"Operator": {
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type": {
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	resp.data.Data.Rules.push(ruleJson());
};

export const addRoleBasedValidation = [key, applicable, modify];